import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SensorStateIndicatorConfigurationEditComponent } from './sensor-state-indicator-configuration-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterableSelectModule } from 'src/app/_shared/components/filterable-select/filterable-select.module';

@NgModule({
  declarations: [SensorStateIndicatorConfigurationEditComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FlexModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatTooltipModule,
    FilterableSelectModule,
  ],
})
export class SensorStateIndicatorConfigurationEditModule {}
